export default "__VITE_ASSET__B4j7MYc4__"